import axios, { AxiosResponse, CancelTokenSource } from "axios";
import UserStore from "../store/UserStore";
import { UserState } from "../state/UserState";
import { UserState as UserStateType } from "../state/UserState";

import Axios from "axios";
import {
  CentreSetupResponse,
  CsvMessageRow,
  LocalKioskAttractor,
} from "../types/index";
import { apiBaseUrl } from "..";

class PeApiClient {
  userStore = UserStore;
  userState!: UserState;

  init(userState: UserStateType) {
    this.userState = userState;
    Axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (
          401 === error?.response?.status ||
          403 === error?.response?.status
        ) {
          console.log("FOUND 401 STATUS");
          userState.logout();
        } else {
          return Promise.reject(error);
        }
      }
    );

    Axios.defaults.withCredentials = true;
  }

  /** VENUE THEME / AUTH ENDPOINTS **/
  userLogin(email: string, PIN: string) {
    return axios.post(apiBaseUrl + "/v1/venue-admin/login", {
      email: email,
      PIN: PIN,
    });
  }

  userExtras(): Promise<AxiosResponse<CentreSetupResponse>> {
    return Axios.get(
      `${apiBaseUrl}/v1/cc-user/${this.userState.user?.userId}/centre-setup`
    );
  }

  userLogout() {
    return axios.post(apiBaseUrl + "/v1/venue-admin/logout");
  }

  getValidVenues() {
    return axios.get(apiBaseUrl + "/v1/pe-admin/venue-list");
  }

  /** GEO ENDPOINTS **/

  addNewGeofence(name: string, updatedCoordinates: any) {
    return axios.post(apiBaseUrl + "/v1/pe-admin/add-geofence", {
      name: name,
      coordinates: updatedCoordinates,
    });
  }

  updateGeofence(locationId: string, name: string, updatedCoordinates: any[]) {
    return axios.post(
      apiBaseUrl + "/v1/pe-admin/update-geofence/" + locationId,
      {
        name: name,
        coordinates: updatedCoordinates,
      }
    );
  }

  deleteGeofence(locationId: string) {
    return axios.post(
      apiBaseUrl + "/v1/pe-admin/delete-geofence/" + locationId
    );
  }

  /** HYDRA ENDPOINTS **/

  getHydraVenueConfig() {
    let url =
      apiBaseUrl +
      "/v1/venue-admin/" +
      this.userState.getVenueId +
      "/hydra/venue-config";
    // let config = {
    //     cancelToken: cancelToken.token
    // };

    return axios.get(url);
  }

  updateHomeContent(homeContentHtml: string) {
    let url =
      apiBaseUrl +
      "/v1/venue-admin/" +
      this.userState.getVenueId +
      "/hydra/update-home-content";
    // let config = {
    //     cancelToken: cancelToken.token
    // };

    return axios.post(url, {
      homeContentHtml,
    });
  }

  /** ANALYTICS ENDPOINTS **/

  getGeoData(
    daysAgo: number,
    hoursAgo: number,
    cancelToken: CancelTokenSource
  ) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/geo/analytics",
      {
        daysAgo: daysAgo,
        hoursAgo: hoursAgo,
      },
      config
    );
  }

  getGeoActiveUsersData(days: number, cancelToken: CancelTokenSource) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/daily-geo-active-users?daysAgo=" +
        days,
      config
    );
  }

  getActiveUsersVsGeoActiveUsersData(
    days: number,
    cancelToken: CancelTokenSource
  ) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/daily-vs-geo-users?daysAgo=" +
        days,
      config
    );
  }

  getStickinessData(days: number, cancelToken: CancelTokenSource) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/stickiness?daysAgo=" +
        days,
      config
    );
  }

  getUserRetention(cancelToken: CancelTokenSource) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/user-retention",
      config
    );
  }

  /** MOBILE ATTRACTOR ENDPOINTS **/

  deleteMobileAttractor(attractorId: number) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/mobile-attractors/delete/" +
        attractorId
    );
  }

  /** KIOSK ENDPOINTS **/

  getKioskAllHealth() {
    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/kiosk/health-all"
    );
  }

  getKioskAttractors() {
    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/kiosk/attractors"
    );
  }

  createKioskAttractor(
    imageS3Key: string,
    attractor: LocalKioskAttractor,
    cancelToken: CancelTokenSource
  ) {
    return axios
      .post(
        apiBaseUrl +
          "/v1/venue-admin/" +
          this.userState.getVenueId +
          "/kiosk/create-attractor",
        {
          mediaS3Key: imageS3Key,
          startDateEpoch: attractor.startDateEpoch,
          endDateEpoch: attractor.endDateEpoch,
          dayVisibility: attractor.dayVisibility,
        },
        {
          cancelToken: cancelToken.token,
        }
      )
      .catch((error: any) => {});
  }

  updateKioskAttractor(
    attractorId: number,
    startDateEpoch: number,
    endDateEpoch: number,
    dayVisibility: string
  ) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/kiosk/update-attractor/" +
        attractorId,
      {
        startDateEpoch: startDateEpoch,
        endDateEpoch: endDateEpoch,
        dayVisibility: dayVisibility,
      }
    );
  }

  /** App About Us Calls **/
  getAppAboutUsItems() {
    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/app-about-items"
    );
  }

  updateAppAboutUsItem(
    aboutUsItemId: number,
    newItemDisplayText: string,
    newItemUrl: string
  ) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/update-app-about-item/" +
        aboutUsItemId,
      {
        displayText: newItemDisplayText,
        displayLinkUrl: newItemUrl,
      }
    );
  }

  /** App Banner Calls **/

  /** Communiations **/
  scheduleNotfication(
    scheduleTime: number,
    title: string,
    message: string,
    messageType?: string,
    tierOption?: string
  ) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/u/" +
        this.userState.user?.userId +
        "/notif-schedule/create",
      {
        scheduleType: "OnceInFuture",
        notificationType: messageType,
        notificationTitle: title,
        notificationMessage: message,
        notificationScheduleTime: scheduleTime,
        tierOption: tierOption,
      }
    );
  }

  // sendVenueFlashMessage(body: { title: string; message: string }) {
  //   return axios
  //     .post(
  //       apiBaseUrl +
  //         '/v1/venue-admin/' +
  //         this.userState.getVenueId +
  //         '/create-flash-message/venue',
  //       body
  //     )
  //     .catch((error: any) => {
  //       console.log('Error sending venue flash message');
  //       console.log('error', error);
  //     });
  // }

  sendCsvFlashMessage(
    recipients: CsvMessageRow[],
    cancelToken: CancelTokenSource
  ) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios
      .post(
        apiBaseUrl +
          "/v1/venue-admin/" +
          this.userState.getVenueId +
          "/create-flash-message/csv",
        {
          recipients: recipients,
        },
        config
      )
      .catch((error: any) => {});
  }

  verifySingleRecipient(badgeNumber: string, cancelToken: CancelTokenSource) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/verify-badge-number/" +
        badgeNumber,
      null,
      {
        cancelToken: cancelToken.token,
      }
    );
  }

  getTierOptions() {
    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/get-filter-options"
    );
  }

  getVenueTierOptions(cancelToken: CancelTokenSource) {
    let config = {
      cancelToken: cancelToken.token,
    };

    return axios.get(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/get-filter-options",
      config
    );
  }

  sendCustomFlashMessage(title: string, message: string, tierOption: string) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/create-flash-message/filtered",
      {
        tierOption: tierOption,
        title: title,
        message: message,
      }
    );
  }

  updateBannerText(appBannerText: string) {
    return axios.post(
      apiBaseUrl +
        "/v1/venue-admin/" +
        this.userState.getVenueId +
        "/mobile/app-banner-text",
      {
        appBannerText: appBannerText,
      }
    );
  }

  async getPresignedS3UploadUrl(
    thumbFileName: string,
    fullFileName: string,
    cancelToken: CancelTokenSource
  ) {
    return axios
      .post(
        apiBaseUrl +
          "/v1/user/" +
          this.userState.user?.userId +
          "/venue-admin/" +
          this.userState.getVenueId +
          "/upload-url",
        {
          thumbFileName: thumbFileName,
          fullFileName: fullFileName,
        },
        {
          cancelToken: cancelToken.token,
        }
      )
      .catch((error: any) => {});
  }

  async getSingleUploadPresignedS3Url(
    imageFileName: string,
    cancelToken: CancelTokenSource
  ) {
    return axios
      .post(
        apiBaseUrl +
          "/v1/user/" +
          this.userState.user?.userId +
          "/venue-admin/" +
          this.userState.getVenueId +
          "/upload-url-single",
        {
          imageFileName: imageFileName,
        },
        {
          cancelToken: cancelToken.token,
        }
      )
      .catch((error: any) => {});
  }

  async uploadToS3PresignedUrl(
    url: string,
    data: any,
    cancelToken: CancelTokenSource,
    progressCallback: (percentCompleted: number) => void
  ) {
    let config = {
      onUploadProgress: (progressEvent: any) => {
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );

        progressCallback(percentCompleted);

        console.log("percent: " + percentCompleted);
      },
      withCredentials: false,
      cancelToken: cancelToken.token,
    };

    return axios.put(url, data, config);
  }
}

const apiClient = new PeApiClient();
export default apiClient;
